/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef } from 'react';
import { Button, Form, Row, Col, FormControl, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
// project imports
import { bidderReport, salelist, reportsLocationList } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Bidder.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to show bidder repor in table
 * 
 * @param props
 * 
 * @return bidder html code
 * 
**/


const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="custom-drop-down-report"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));

export default class Bidder extends Component {
    initialSearchState;
    search;
    constructor(props) {
        super(props);
        /* initial search state */
        this.initialSearchState = {
            saletitle: { field: "saletitle", value: "", op: "=", join: "AND" },
            saleid: { field: "saleid", value: "", op: "=", join: "AND" },
            firstname: { field: "firstname", value: "", op: "LIKE", join: "AND" },
            lastname: { field: "lastname", value: "", op: "LIKE", join: "AND" },
            nickname: { field: "nickname", value: "", op: "=", join: "AND" },
            email: { field: "email", value: "", op: "LIKE", join: "AND" },
            locationid: { field: 'locationid', value: "", op: '=', join: 'AND' },
            starttime: { field: 'bidcreateddate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'bidcreateddate', value: '', op: '<=', join: 'AND' }
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            sales: [],
            tableData: [],
            locations: [],
            issearch: false,
            searchInput: null,
            showSearchBox: false,
            isdisabled: false,
            location: '',
            locationlength: 0,
            Selected_salename: "",
            errorpageredirect: false,
            errorType: ''
        }

        this.config = {
            name: 'bidder report',
            url: bidderReport,
            isReport: true, 
            params: {},
            columns: [
                { name: 'First Name', property: 'firstname', sort: false, width: '130px' },
                { name: 'Last Name', property: 'lastname', sort: false, width: '130px' },
                { name: 'User Name', property: 'nickname', sort: false, width: '130px' },
                { name: 'Last Buy Win Date', property: 'lastbuydate', sort: false, width: '130px', columnType: 'custom', customColumn: (row) => this.customDate(row, "lastbuydate") },
                { name: 'Status', property: 'buyerbidstatus', sort: false, width: '130px' },
                { name: 'Tax Exempt', property:'istaxExempt', sort: false, width: '130px', columnType: 'custom', customColumn: (data) => this.taxException(data, "taxexemptstatus") },
                { name: 'Exemption Approved', property:'taxexemptstatus', sort: false, width: '150px', columnType: 'custom', customColumn: (data) => this.ExemptionApproved(data, "taxexemptstatus") },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: "CSV", width: '170px',
                    actionEvents: {}, accordion: this.accordionValue
                }
            ],
            sort: [],
            pagination: true,
            field: ["firstname", "lastname", "nickname", "locationid", "email", "signupdate", "country", "state", "city", "address1", "address2", "zipcode", "timezone", "lastbuydate", "buyerbidstatus", "istaxExempt", "taxexemptstatus"],
            filename: "bidder-report",
            // defaultFilter: [{ field: 'salestatus', value: 'Closed', op: '=', join: 'AND' }],
            csvColumn: [
                // { name: 'Item ID', property: 'itemid', },
                { name: 'Address', columnType: 'custom', customColumn: this.customAddress },
                // { name: 'Address 2', property: 'address2', },
                // { name: 'Buyer Bid Status', property: 'buyerbidstatus', },
                { name: 'City', property: 'city', },
                { name: 'Country', property: 'country', },
                { name: 'Email', property: 'email', },
                { name: 'Phone', property: 'mobilenumber', },
                { name: 'Signup Date', property: 'signupdate', columnType: 'custom', customColumn: (row) => this.customDate(row, "signupdate") },
                { name: 'State / Province', property: 'state', },
                { name: 'Zip / Postal Code', property: 'zipcode', },
            ]
        };
        this.search = {};
        this.sales = [];
        this.filterSearch = {};
        this.dataTable = createRef();
        this.locations = [];
    }

    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto my-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );
    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    customDate(row, type) {
        if (row[type] != null)
            return `${moment.utc(row[type]).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        else
            return '- - -';
    }
    taxException(data, type) {
        return (data[type] == "APPROVED") ? 'Yes' : 'No';
    }

    ExemptionApproved(data, type) {
       return (data[type] !== "PENDING" && data[type] !== "N/A" && data[type] !== "REJECTED" && data[type] !== "EXPIRED") ? 'APPROVED' : data[type];
    }

    customAddress = (values) => {
        if (values.address2) {
            const res = values.address1 + ' ,' + values.address2;
            return res;
        }
        else {
            const res = values.address1;
            return res;
        }
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'saleid') {
            eventValue = Number(eventValue)
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    errorMessage: '',
                    search: {
                        ...this.state.search,
                        starttime: {
                            ...this.state.search.starttime,
                            value:''
                        },
                        endtime: {
                            ...this.state.search.endtime,
                            value:''
                        }
                    }
                })
            }, 10);
        }
        if (event.target.name === 'locationid') {
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                Selected_salename: "",
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: Number(eventValue)
                    }
                }
            }, () => {
                this.getSaleList(true);
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
        else {
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }

    // taxException(data, type) {
    //     return data[type] == "0" ? "No" : "Yes";
    // }

    // ExemptionApproved(data, type) {
    //    return data[type] === "0" ? 'EXPIRED' : (data[type] === "1" ? 'APPROVED' : data[type]);
    // }

    /* Get sales list */
    getSaleList = (locationChange = false) => {
        let filter = []
        if (!this.state.search.locationid.value) {
            filter = [
                { field: 'status', value: 'Closed', op: '=', join: 'OR' },
                { field: 'status', value: 'Started', op: '=', join: 'AND' },
                { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        } else {
            filter = [
                { field: 'locationid', value: this.state.search.locationid.value, op: '=', join: 'AND' },
                { field: 'status', value: 'Closed', op: '=', join: 'OR' },                
                { field: 'status', value: 'Started', op: '=', join: 'AND' },
                { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }
        if(locationChange){
            this.setState({
                ...this.state,
                search: {
                    ...this.state.search,
                    saleid: {
                        ...this.state.search.saleid,
                        value: '',
                    }
                }
            });

        }
       
        let field = ["title", "id"]
        var data = {
            "field": field,
            "filter": filter
        };
        axios.post(getSellerUrl(salelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.sales = response.data.data;
                    const temp = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        ...this.state,
                        sales: temp,
                    });
                }
            })
            .catch(error => {
            });
    }
    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            Selected_salename: ""
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }


    /* called when search button clicked */
    enableSearch = () => {
        let startDate = null
        let endDate = null

        if (this.state.search.starttime.value) {
            let startDateFormat = moment(this.state.search.starttime.value).format("YYYY-MM-DD")
            startDate = moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        }

        if (this.state.search.endtime.value) {
            let endDateformat = moment(this.state.search.endtime.value).format("YYYY-MM-DD")
            endDate = moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        }
        var search = {
            saleid: { ...this.state.search.saleid, value: this.state.search.saleid.value },
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value !== '' && `%${this.state.search.firstname.value}%` },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value !== '' && `%${this.state.search.lastname.value}%` },
            nickname: { ...this.state.search.nickname, value: this.state.search.nickname.value !== '' && this.state.search.nickname.value },
            email: { ...this.state.search.email, value: this.state.search.email.value !== '' && `%${this.state.search.email.value}%` },
            locationid: { ...this.state.search.locationid },
            starttime: { ...this.state.search.starttime, value: startDate || '' },
            endtime: { ...this.state.search.endtime, value: endDate ||  '' },
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    serachValueCheck = () =>{
        if(this.state.search.saleid.value){
            return false
        }
        else if(this.state.search.endtime.value && this.state.search.starttime.value){
            return false
        }
        else{
            return true
        }
          
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div className="accordion-view" style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex">
                        <div style={{ margin: "0 1%" }}>
                            {"email" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Email Address</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["email"]}</div>
                            </div>}
                            {"mobilenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Phone Number</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["mobilenumber"]}</div>
                            </div>}
                        </div>
                        <div style={{ margin: "0 1%" }}>
                            {"address1" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Address</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["address1"]}</div>
                            </div>}
                            {"city" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">City</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["city"]}</div>
                            </div>}
                            {"state" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">State</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["state"]}</div>
                            </div>}
                        </div>
                        <div style={{ margin: "0 1%" }}>
                            {"timezone" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Time Zone</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{row["timezone"]}</div>
                            </div>}
                            {"signupdate" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Signup Date</div>
                                <div className="accordion-row-text">:  &nbsp;&nbsp;{this.customDate(row, "signupdate")}</div>
                            </div>}
                        </div>

                    </div>
                    : ''}
            </div>
        );
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        const { search } = this.state;
        let errorMessage = '';
    
        // always update in state
        const updatedSearch = {
            ...search,
            [control]: {
                ...search[control],
                value: date
            }
        };
    
        // validate only when both dates exist
        if (updatedSearch.starttime.value && updatedSearch.endtime.value) {
            const start = new Date(updatedSearch.starttime.value);
            const end = new Date(updatedSearch.endtime.value);
    
            const monthsDiff =
                (end.getFullYear() - start.getFullYear()) * 12 +
                (end.getMonth() - start.getMonth());

            if (end < start) {
                errorMessage = "Please select a date range within any 12 month period";
                updatedSearch.endtime.value = null;
            }
            else if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate())) {
                errorMessage = "Please select a date range within any 12 month period";
            }
        }
    
        this.setState({
            issearch: true,
            errorMessage,
            search: updatedSearch
        });
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            this.setState({
                showSearchBox: event,
                sales: [],
                searchInput: null,
            });
        }, event ? 500 : 100);
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            this.getSaleList();
        });
    }

    saleSelect = (sale) => {
        if (this.state.search.saletitle.value !== sale.title) {
            this.setState({
                searchInput: null,
                sales: [],
                Selected_salename: sale.title
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.searchInputChange(event);
            });
        }
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(reportsLocationList, '' , true), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    }, () => {
                        this.getSaleList();
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                    })
                }
            })
            .catch(error => {
                if(error?.response?.status == 401 || error?.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        {/* <label>Phone Number</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="mobilenumber" value={this.state.search.mobilenumber.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control> */}
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Please select location</option>
                                            {/* {this.state.locations.length > 1 ? <option value="All">All</option> : ''} */}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale Title</label>
                                        {/* <Form.Control as="select" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value="" >Select Sale</option>
                                            {this.state.sales.map((sale, index) =>
                                                <option key={index} value={sale.id}>{sale.title}</option>
                                            )}
                                        </Form.Control> */}
                                        <Dropdown onToggle={(event) => this.toggleSearchBox(event)}>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                {this.state.Selected_salename ? this.state.Selected_salename : "Select Sale"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu as={this.CustomMenu} className="custom-dropdown-menu" >

                                                {this.state.sales.map((sale, index) => {
                                                    return (
                                                        <Dropdown.Item key={sale.id} eventKey={sale.title} onClick={() => this.saleSelect(sale)} active={this.state.search.saletitle.value === sale.title}>
                                                            {sale.title}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                    <Col>
                                        <label>First Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="firstname" value={this.state.search.firstname.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Last Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="lastname" value={this.state.search.lastname.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <label>User Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="nickname" value={this.state.search.nickname.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Email Address</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="email" value={this.state.search.email.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Last Bid Date From {!this.state.search.saleid.value && '*'}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker  disabled={this.state.search.saleid.value}  ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Last Bid Date To {!this.state.search.saleid.value && '*'}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker  disabled={this.state.search.saleid.value}  minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                    <Col>
                                    </Col>
                                    <Col className="d-flex justify-content-center align-items-center">
                                        {(this.state.errorMessage )&& (
                                            <div className="text-danger text-center"  style={{fontSize: '14px'}}>
                                                {this.state.errorMessage}
                                            </div>
                                        )}
                                    </Col>
                                    <Col>
                                        <div className="buttonClass">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={(this.state.locationlength > '1' ? !this.state.isdisabled : !this.state.isdisabled )|| this.state.errorMessage ||  this.serachValueCheck()} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}